function BankModel({ value, label, code }) {
    let obj = {};
    obj.value = value;
    obj.label = label;
    obj.code = code;
    return obj;
  }
  
  export default BankModel;
  